var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3178_9066)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 17.5,
    r: 10.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2202 20.2202C25.8342 20.6061 25.376 20.9123 24.8718 21.1211C24.3675 21.33 23.8271 21.4375 23.2812 21.4375C22.1789 21.4375 21.1218 20.9996 20.3423 20.2202C19.5629 19.4407 19.125 18.3836 19.125 17.2812C19.125 16.1789 19.5629 15.1218 20.3423 14.3423C21.1218 13.5629 22.1789 13.125 23.2812 13.125C23.8271 13.125 24.3675 13.2325 24.8718 13.4414C25.376 13.6502 25.8342 13.9564 26.2202 14.3423C26.6061 14.7283 26.9123 15.1865 27.1211 15.6907C27.33 16.195 27.4375 16.7354 27.4375 17.2812C27.4375 17.8271 27.33 18.3675 27.1211 18.8718C26.9123 19.376 26.6061 19.8342 26.2202 20.2202ZM26.2202 20.2202L27.875 21.875",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3178_9066",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.611765 0 0 0 0 0.882353 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3178_9066"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3178_9066",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconMobile);
export default __webpack_public_path__ + "static/media/SearchIconMobile.1af0417e12c4d00c33a3d0c6fc02c36c.svg";
export { ForwardRef as ReactComponent };